import React, { useContext, useEffect, useRef, useState } from "react";
import Header from "../../../Components/Header";
import Footer from "../../../Components/Footer";
import { useModalContext } from "../../../Context/ModalContext";
import "./index.css";
import { MdOutlineSwapVert } from "react-icons/md";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  ExecuteQuote,
  getSupportedConversions,
  RequestQuote,
  RequestQuoteGuest,
} from "../../../Features/Convert/convertSlice";
import { Modal, Button } from "react-bootstrap";
import { FaExchangeAlt } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { getBalance } from "../../../Components/Wallet";
import useDebounce from "../../../Hooks/useDebounce";
import { GetCryptoPrice } from "../../../Features/Market/marketSlice";
import { WebSocketContext } from "../../../Context/WebSocketContext";
const Convert = () => {
  const { selectedTheme } = useModalContext();
  const { supportedConversions } = useSelector((state) => state.convert);
  const { userBalance } = useContext(WebSocketContext);
  const { cryptoPriceList } = useSelector((state) => state.market);
  const [isDropDownOpenTo, setIsDropdownOpenTo] = useState(false);
  const [isDropDownOpenFrom, setIsDropdownOpenFrom] = useState(false);
  const [selectFrom, setSelectedFrom] = useState("");
  const [selectTo, setSelectedTo] = useState("");
  const [selectFromOption, setSelectedFromOption] = useState([]);
  const [selectToOption, setSelectedToOption] = useState([]);
  const [show, setShow] = useState(false);
  const navigate = useNavigate();
  const [fromAmount, setFromAmount] = useState(0);
  const [toAmount, setToAmount] = useState(0);
  const [fromBalance, setFromBalance] = useState(0);
  const [toBalance, setToBalance] = useState(0);
  const [previewConversionData, setPreviewConversionData] = useState([]);
  const [fiatToPrice, setFiatToPrice] = useState(0);
  const [fiatFromPrice, setFiatFromPrice] = useState(0);
  const [timer, setTimer] = useState(10);
  const [isTimerRunning, setIsTimerRunning] = useState(false);
  const [rate, setRate] = useState(0);
  const [inverseRate, setInverseRate] = useState(0);
  const labels = useSelector((state) => state.labels.data);

  const handleClose = () => {
    setShow(false);
    setPreviewConversionData([]);
    setIsTimerRunning(false);
    setTimer(0);
  };
  const handleShow = () => {
    if (
      fromAmount === 0 ||
      toAmount === 0 ||
      fromAmount <= 0 ||
      toAmount <= 0
    ) {
      toast.error(labels.convert.enterValidAmount);
      return;
    } else {
      setShow(true);
      dispatch(getSupportedConversions()).then((d) => {
        setTimer(d?.payload?.data?.duration);
        setIsTimerRunning(true);
      });
      if (localStorage.getItem("token")) {
        dispatch(
          RequestQuote({
            from: selectFrom,
            to: selectTo,
            amountFrom: fromAmount,
          })
        ).then((d) => {
          setPreviewConversionData(d?.payload?.data);
        });
      } else {
        dispatch(
          RequestQuoteGuest({
            from: selectFrom,
            to: selectTo,
            amountFrom: fromAmount,
          })
        ).then((d) => {
          setPreviewConversionData(d?.payload?.data);
        });
      }
    }
  };
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSupportedConversions()).then((d) => {
      setSelectedFrom(d?.payload?.data?.conversions[0]?.from);
      setSelectedFromOption(d?.payload?.data?.conversions);
      const to = d?.payload?.data?.conversions?.filter(
        (item) => item?.from === d?.payload?.data?.conversions[0]?.from
      )[0]?.to[0];
      setSelectedTo(to);
      const toOptions = d?.payload?.data?.conversions?.filter(
        (item) => item?.from === d?.payload?.data?.conversions[0]?.from
      )[0]?.to;
      setSelectedToOption(toOptions);
    });
  }, []);

  useEffect(() => {
    dispatch(GetCryptoPrice());
  }, []);

  useEffect(() => {
    setFromBalance(userBalance[selectFrom]?.balance || 0);
    setToBalance(userBalance[selectTo]?.balance || 0);

    // if (localStorage.getItem("token") && selectFrom && selectTo) {
    //   getBalance().then((d) => {
    //     const from_bal = d?.data?.data?.filter(
    //       (d) => d?.currency === selectFrom
    //     )[0]?.balance;
    //     setFromBalance(from_bal);
    //     const to_bal = d?.data?.data?.filter((d) => d?.currency === selectTo)[0]
    //       ?.balance;
    //     setToBalance(to_bal);
    //   });
    // }
  }, [selectFrom, selectTo, userBalance]);

  const displayTradeButton = () => {
    return (
      <button className="button pointer" onClick={handleShow}>
        {labels?.convert?.previewConversion ||
          "labels.convert.previewConversion"}
      </button>
    );
  };

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (isDropDownOpenTo && !e.target.closest(".lb-dropdown")) {
        setIsDropdownOpenTo(false);
      }
      if (isDropDownOpenFrom && !e.target.closest(".lb-dropdown")) {
        setIsDropdownOpenFrom(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isDropDownOpenTo, isDropDownOpenFrom]);

  const handleFromSelect = (value) => {
    setSelectedFrom(value);
    setIsDropdownOpenFrom(false);
    const toOptions = supportedConversions?.data?.conversions?.filter(
      (item) => item?.from === value
    )[0]?.to;
    setSelectedToOption(toOptions);
    const to = supportedConversions?.data?.conversions?.filter(
      (item) => item?.from === value
    )[0]?.to[0];
    setSelectedTo(to);

    if (
      fromAmount === 0 ||
      toAmount === 0 ||
      fromAmount <= 0 ||
      toAmount <= 0 ||
      fromAmount === ""
    ) {
      setFromAmount(0);
      setToAmount(0);
      return;
    } else {
      if (localStorage.getItem("token")) {
        dispatch(
          RequestQuote({
            from: value,
            to: to,
            amountFrom: fromAmount,
          })
        ).then((d) => {
          if (d?.payload?.status === 0) {
            setToAmount(d?.payload?.data?.amountTo);
          } else {
            toast.error(d?.payload?.message);
            setToAmount(0);
            setFiatToPrice(0);
          }
        });
      } else {
        dispatch(
          RequestQuoteGuest({
            from: value,
            to: selectTo,
            amountFrom: fromAmount,
          })
        ).then((d) => {
          if (d?.payload?.status === 0) {
            setToAmount(d?.payload?.data?.amountTo);
          } else {
            toast.error(d?.payload?.message);
            setToAmount(0);
            setFiatToPrice(0);
          }
        });
      }
    }
  };

  const handleToSelect = (value) => {
    setSelectedTo(value);
    setIsDropdownOpenTo(false);

    if (fromAmount <= 0 || fromAmount === 0 || fromAmount === "") {
      return; // Don't call API
    }
    if (localStorage.getItem("token")) {
      dispatch(
        RequestQuote({
          from: selectFrom,
          to: value,
          amountFrom: fromAmount,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setToAmount(d?.payload?.data?.amountTo);
        } else {
          toast.error(d?.payload?.message);
          setFromAmount(0);
          setToAmount(0);
          setFiatFromPrice(0);
        }
      });
    } else {
      dispatch(
        RequestQuoteGuest({
          from: selectFrom,
          to: value,
          amountFrom: fromAmount,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setToAmount(d?.payload?.data?.amountTo);
        } else {
          toast.error(d?.payload?.message);
          setFromAmount(0);
          setFiatFromPrice(0);
        }
      });
    }
  };

  const handleChange = () => {
    const temp = selectFrom;
    setSelectedFrom(selectTo);
    setSelectedTo(temp);
    const newFromValue = selectTo;
    const toOptions = supportedConversions?.data?.conversions?.filter(
      (item) => item?.from === newFromValue
    )[0]?.to;
    setSelectedToOption(toOptions);

    const temp1 = fromAmount;
    setFromAmount(toAmount);
    setToAmount(temp1);

    if (localStorage.getItem("token")) {
      dispatch(
        RequestQuote({
          from: selectTo,
          to: selectFrom,
          amountFrom: toAmount,
        })
      ).then((d) => {
        setToAmount(d?.payload?.data?.amountTo);
      });
    } else {
      dispatch(
        RequestQuoteGuest({
          from: selectTo,
          to: selectFrom,
          amountFrom: toAmount,
        })
      ).then((d) => {
        setToAmount(d?.payload?.data?.amountTo);
      });
    }
  };

  const debouncedFromRequest = useDebounce((value) => {
    if (localStorage.getItem("token")) {
      dispatch(
        RequestQuote({
          from: selectFrom,
          to: selectTo,
          amountFrom: value,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setToAmount(d?.payload?.data?.amountTo);
        } else {
          toast.error(d?.payload?.message);
          setRate(0);
        }
      });
    } else {
      dispatch(
        RequestQuoteGuest({
          from: selectFrom,
          to: selectTo,
          amountFrom: value,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setToAmount(d?.payload?.data?.amountTo);
        } else {
          toast.error(d?.payload?.message);
        }
      });
    }
  }, 500);
  const debouncedToRequest = useDebounce((value) => {
    if (localStorage.getItem("token")) {
      dispatch(
        RequestQuote({
          from: selectFrom,
          to: selectTo,
          amountTo: value,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setFromAmount(d?.payload?.data?.amountFrom);
        } else {
          toast.error(d?.payload?.message);
        }
      });
    } else {
      dispatch(
        RequestQuoteGuest({
          from: selectFrom,
          to: selectTo,
          amountTo: value,
        })
      ).then((d) => {
        if (d?.payload?.status === 0) {
          setFromAmount(d?.payload?.data?.amountFrom);
        } else {
          toast.error(d?.payload?.message);
        }
      });
    }
  }, 500);

  const handleFromAmountChange = (e) => {
    const value = e.target.value;
    setFromAmount(value);
    if (e.target.value === "" || e.target.value == 0 || e.target.value <= 0) {
      setFromAmount(0);
      setToAmount(0);
      setFiatFromPrice(0);
      setFiatToPrice(0);
    } else {
      if (value > 0) {
        debouncedFromRequest(value);
      }
    }
  };

  const handleToAmountChange = (e) => {
    const value = e.target.value;
    setToAmount(value);
    if (e.target.value === "" || e.target.value == 0 || e.target.value <= 0) {
      setToAmount(0);
      setFromAmount(0);
      setFiatFromPrice(0);
      setFiatToPrice(0);
    } else {
      if (value > 0) {
        debouncedToRequest(value);
      }
    }
  };
  const convertFromTo = () => {
    dispatch(ExecuteQuote(previewConversionData?.quoteID)).then((d) => {
      if (d?.payload?.status === 0) {
        toast.success("Conversion successful!");
        setFromAmount(0);
        setToAmount(0);
        handleClose();
      } else {
        toast.error(d?.payload?.message);
      }
    });
  };

  useEffect(() => {
    if (
      fiatToPrice === undefined ||
      fiatFromPrice === undefined ||
      isNaN(fiatToPrice) ||
      isNaN(fiatFromPrice)
    ) {
      setFiatFromPrice(0);
      setFiatToPrice(0);
    } else {
      const fiatToPriceFilter = cryptoPriceList?.data?.rateList?.filter(
        (item) => item?.currency === selectTo
      )[0]?.rate;
      if (fiatToPriceFilter && toAmount) {
        setFiatToPrice(fiatToPriceFilter * toAmount);
      } else {
        setFiatToPrice(0);
      }

      const fiatFromPriceFilter = cryptoPriceList?.data?.rateList?.filter(
        (item) => item?.currency === selectFrom
      )[0]?.rate;
      if (fiatFromPriceFilter && fromAmount) {
        setFiatFromPrice(fiatFromPriceFilter * fromAmount);
      } else {
        setFiatFromPrice(0);
      }
    }
  }, [fromAmount, toAmount]);

  useEffect(() => {
    let interval;
    if (isTimerRunning && timer > 0) {
      interval = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    } else if (isTimerRunning && timer === 0) {
      setIsTimerRunning(false);
      handleClose();
      debouncedFromRequest(fromAmount);
    }
    return () => clearInterval(interval);
  }, [timer, isTimerRunning]);

  useEffect(() => {
    if (
      fromAmount === 0 ||
      toAmount === 0 ||
      isNaN(fromAmount) ||
      isNaN(toAmount)
    ) {
      setRate(0);
      setInverseRate(0);
    } else {
      const rate = (toAmount / fromAmount).toFixed(8);
      const inverseRate = (fromAmount / toAmount).toFixed(8);
      setRate(rate);
      setInverseRate(inverseRate);
    }
  }, [fromAmount, toAmount, selectFrom, selectTo]);

  if (supportedConversions?.data === null) {
    return (
      <div>
        <Header />
        <div className="container">
          <div className="trade-card">
            <p className="head" style={{ marginBottom: 0 }}>
              {labels?.convert?.noPairAvailable ||
                "labels.convert.noPairAvailable"}
            </p>
          </div>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div>
      <Header />
      <div className="container">
        <div className="trade-card">
          <div className="head">
            <img
              src={
                selectedTheme.name === "dark"
                  ? "images/icons/fire.svg"
                  : "images/icons/fire-black.svg"
              }
              alt=""
            />
            {labels?.convert?.convert || "labels.convert.convert"}
          </div>
          <div className="convert_body">
            <div className="d-flex justify-content-between">
              <p className="heading">
                {" "}
                {labels?.convert?.from || "labels.convert.from"}
              </p>
              {localStorage.getItem("token") && (
                <p className="rate_estimate">
                  {labels?.convert?.balance || "labels.convert.balance"}:{" "}
                  {fromBalance} {selectFrom}
                </p>
              )}
            </div>
            <div className="convert_input">
              <div className="row flex align-items-center">
                <div className="col-7 col-md-9">
                  <input
                    type="number"
                    id="to"
                    placeholder="0"
                    min={0}
                    value={fromAmount}
                    onChange={handleFromAmountChange}
                  />
                  <span className="estimate">≈ {fiatFromPrice.toFixed(2)}</span>
                </div>
                <div className="col-5 col-md-3">
                  <div className="lb-dropdown">
                    <div
                      className="lb-default-option d-flex justify-content-between"
                      onClick={() => {
                        setIsDropdownOpenFrom(!isDropDownOpenFrom);
                        setIsDropdownOpenTo(false);
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={`/images/coins/${selectFrom?.toLowerCase()}.svg`}
                          width={25}
                        />
                        <span>{selectFrom}</span>
                      </div>
                    </div>
                    {isDropDownOpenFrom && (
                      <div className="lb-options mt-2">
                        {selectFromOption?.map((item, index) => {
                          return (
                            <div
                              className="lb-option d-flex align-items-center gap-2"
                              onClick={() => handleFromSelect(item?.from)}
                              key={index}
                            >
                              <img
                                src={`/images/coins/${item?.from?.toLowerCase()}.svg`}
                                width={25}
                              />
                              <span>{item?.from}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="swap_icon">
              <hr />
              <MdOutlineSwapVert className="swap_btn" onClick={handleChange} />
            </div>
            <div className="d-flex justify-content-between">
              <p className="heading">
                {labels?.convert?.to || "labels.convert.to"}
              </p>
              {localStorage.getItem("token") && (
                <p className="rate_estimate">
                  {labels?.convert?.balance || "labels.convert.balance"}:{" "}
                  {toBalance} {selectTo}
                </p>
              )}
            </div>
            <div className="convert_input">
              <div className="row flex align-items-center">
                <div className="col-7 col-md-9">
                  <input
                    type="number"
                    id="to"
                    placeholder="0"
                    min={0}
                    value={toAmount}
                    onChange={handleToAmountChange}
                  />
                  <span className="estimate">≈ {fiatToPrice.toFixed(2)}</span>
                </div>
                <div className="col-5 col-md-3">
                  <div className="lb-dropdown">
                    <div
                      className="lb-default-option d-flex justify-content-between"
                      onClick={() => {
                        setIsDropdownOpenTo(!isDropDownOpenTo);
                        setIsDropdownOpenFrom(false);
                      }}
                    >
                      <div className="d-flex align-items-center gap-2">
                        <img
                          src={`/images/coins/${selectTo?.toLowerCase()}.svg`}
                          width={25}
                        />
                        <span>{selectTo}</span>
                      </div>
                    </div>
                    {isDropDownOpenTo && (
                      <div className="lb-options mt-2">
                        {selectToOption?.map((item, index) => {
                          return (
                            <div
                              className="lb-option d-flex align-items-center gap-2"
                              onClick={() => handleToSelect(item)}
                              key={index}
                            >
                              <img
                                src={`/images/coins/${item?.toLowerCase()}.svg`}
                                width={25}
                              />
                              <span>{item}</span>
                            </div>
                          );
                        })}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>

            <div className="rates">
              <hr />
              <div className="d-flex justify-content-between">
                <span className="heading">
                  {labels?.convert?.rate || "labels.convert.rate"}:
                </span>
                {rate > 0 ? (
                  <p className="rate_estimate">
                    {1} {selectFrom} ≈ {rate} {selectTo}
                  </p>
                ) : (
                  <p className="rate_estimate">
                    {0} {selectFrom} ≈ {rate} {selectTo}
                  </p>
                )}
              </div>
            </div>
            <div className="rates">
              <div className="d-flex justify-content-between">
                <span className="heading">
                  {labels?.convert?.inverseRate || "labels.convert.inverseRate"}
                  :
                </span>
                {inverseRate > 0 ? (
                  <p className="rate_estimate">
                    {1} {selectTo} ≈ {inverseRate} {selectFrom}
                  </p>
                ) : (
                  <p className="rate_estimate">
                    {0} {selectTo} ≈ {inverseRate} {selectFrom}
                  </p>
                )}
              </div>
            </div>
          </div>
          {displayTradeButton()}
        </div>
      </div>
      <Footer />
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>
            {labels?.convert?.convert || "labels.convert.convert"}
          </Modal.Title>
        </Modal.Header>
        <hr />
        <Modal.Body>
          <div className="row modal-body-content d-flex align-items-center">
            <div className="col-5 body-card-left">
              <h5>{labels?.convert?.spend || "labels.convert.spend"}</h5>
              <div className="d-flex justify-content-center mt-3 gap-1">
                <img
                  src={`/images/coins/${selectFrom?.toLowerCase()}.svg`}
                  height={25}
                />
                <span>
                  {previewConversionData?.amountFrom} {selectFrom}
                </span>
              </div>
            </div>
            <div className="col-2 body-card-center d-flex justify-content-center">
              <FaExchangeAlt />
            </div>
            <div className="col-5 body-card-left">
              <h5>{labels?.convert?.receive || "labels.convert.receive"}</h5>
              <div className="d-flex justify-content-center mt-3 gap-1">
                <img
                  src={`/images/coins/${selectTo?.toLowerCase()}.svg`}
                  height={25}
                />
                <span>
                  {previewConversionData?.amountTo} {selectTo}
                </span>
              </div>
            </div>
          </div>
          <div className="mt-4">
            <div className="rates">
              <div className="d-flex justify-content-between">
                <span className="heading">
                  {labels?.convert?.rate || "labels.convert.rate"}:
                </span>
                <p className="rate_estimate">
                  {1} {selectFrom} ≈ {rate} {selectTo}
                </p>
              </div>
            </div>
            <div className="rates">
              <div className="d-flex justify-content-between">
                <span className="heading">
                  {labels?.convert?.inverseRate || "labels.convert.inverseRate"}
                  :
                </span>
                <p className="rate_estimate">
                  {1} {selectTo} ≈ {inverseRate} {selectFrom}
                </p>
              </div>
            </div>
            {/* <div className="rates">
              <div className="d-flex justify-content-between">
                <span className="heading">Transaction Fee:</span>
                <p className="rate_estimate">
                  {previewConversionData?.fee === undefined ||
                  previewConversionData?.fee === null
                    ? 0
                    : Number(previewConversionData.fee).toFixed(8)}{" "}
                  {selectTo}
                </p>
              </div>
            </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          {localStorage.getItem("token") ? (
            <Button
              variant="primary"
              onClick={convertFromTo}
              style={{ width: "100%" }}
            >
              {labels?.convert?.convert || "labels.convert.convert"} ({timer}s)
            </Button>
          ) : (
            <Button
              variant="primary"
              onClick={() => navigate("/login")}
              style={{ width: "100%" }}
            >
              Login or Register
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default Convert;
